import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Subject } from 'rxjs';
import { IFormStore } from '../interface';
import { MyInfoBusinessModel } from '../model';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: MyInfoBusinessModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class BusinessDetailFromInfoStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<MyInfoBusinessModel>((_, data) => ({ state: 'valid', data }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
